<td>{{util.dateToDateString(date.value)}}</td>
<td *ngIf="trackedVisitor === undefined || trackedVisitor === null" class="seperator w-100" colspan="24">
  <button *ngIf="editMode===1" class="btn btn-primary" (click)="createValuesForDate()">
    <sb-icon icon="edit"></sb-icon>
  </button>
</td>
<ng-container *ngIf="!!trackedVisitor">
  <td *ngFor="let index of elements">
    <sb-comp-tracker-values-element
      [tracker]="tracker" [editMode]="editMode"
      [trackerValueElement]="getTrackerValueElementData(index)" [date]="date"
      (valueUpdateEmitter)="handleValueUpdate($event)">
    </sb-comp-tracker-values-element>
  </td>
</ng-container>

